import { render, staticRenderFns } from "./DE.vue?vue&type=template&id=56baf9f2&scoped=true&"
import script from "./DE.vue?vue&type=script&lang=js&"
export * from "./DE.vue?vue&type=script&lang=js&"
import style0 from "./DE.vue?vue&type=style&index=0&id=56baf9f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56baf9f2",
  null
  
)

export default component.exports